import { render, staticRenderFns } from "./game_bd.vue?vue&type=template&id=1eaabcf5&scoped=true"
import script from "./game_bd.vue?vue&type=script&lang=js"
export * from "./game_bd.vue?vue&type=script&lang=js"
import style0 from "./game_bd.vue?vue&type=style&index=0&id=1eaabcf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaabcf5",
  null
  
)

export default component.exports